import React, { useContext, useState, useEffect } from "react";
import { collection, query, where, onSnapshot, orderBy, limit } from "firebase/firestore";
import { ImWarning } from "react-icons/im";

import {AuthContext} from '../services/Session/Context'
import {FirebaseContext} from '../services/Firebase/Context'
import ActivityItem from './ActivityItem'

const Activities = () => {
  const { user } = useContext(AuthContext)
  const { db } = useContext(FirebaseContext)
  const [notifs, setNotifs] = useState([])

  useEffect(() => {
    if(!user) return
    const q = query(collection(db, "notifications"), where("organisationId", "==", user.organisationId), orderBy("createdAt", 'desc'), limit(5));
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const notifs = [];
      querySnapshot.forEach((doc) => {
        notifs.push({id: doc.id, ...doc.data()});
      });
      setNotifs(notifs)
    });
   
    return () => unsubscribe()
  }, [db, user])

  return (
    <div className="shadow-lg rounded-xl w-full p-4 bg-white dark:bg-gray-800 overflow-hidden">
      <div className="w-full flex items-center justify-between mb-8">
          <p className="text-gray-800 dark:text-white text-xl font-normal">
              Activités
          </p>
          {/*<a href="#" className="flex items-center text-sm hover:text-gray-600 dark:text-gray-50 dark:hover:text-white text-gray-300 border-0 focus:outline-none">
              VIEW ALL
          </a>
          */}
      </div>
      {
        notifs && notifs.map((notif) => <ActivityItem key={notif.id} data={notif} />)
      }
      {
        notifs.length === 0 && <div className='text-center'>
          <ImWarning className="h-10 w-10 p-2 mx-auto mb-2 text-yellow-300" />
          <p>Pas d'activités enregistrées pour le moment</p>
        </div>
      }
    </div>
  );
}

export default Activities